import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { closeNewComfirmationDialog, renderNewComfirmationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { useSubscription } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/useSubscription';
import { renderSubscriptionInfoModal } from 'reactApp/ui/Mobile/SubscriptionInfoModal/SubscriptionInfoModal.helpers';

export const useShowSubscriptionModalFromQuery = () => {
    const wasOpenedRef = useRef(false);
    const queryParams = getQueryParams();

    const productsState = useSelector(ProductsSelectors.getLifeCycleState);

    const isFromAction = queryParams?.action === 'show-subscription';
    const id = isFromAction ? queryParams.subscriptionId : '';
    const isFromActionAndLoaded = isFromAction && productsState.isLoaded;
    const subscription = useSubscription({ id });

    useEffect(() => {
        if (wasOpenedRef.current || !isFromActionAndLoaded) {
            return;
        }

        wasOpenedRef.current = true;
        if (subscription) {
            renderSubscriptionInfoModal({ isRebranding: true, subscription });
        } else {
            renderNewComfirmationDialog({
                buttons: [EButtonType.action],
                actionButtonText: 'Закрыть',
                closeOnDimmerClick: true,
                closable: true,
                renderHeader: () => 'Такой подписки нет',
                renderContent: () => (
                    <>
                        Проверьте, корректно&nbsp;ли указана ссылка.
                        <br />
                        Или обратитесь в&nbsp;поддержку
                    </>
                ),
                onClose: closeNewComfirmationDialog,
            });
        }
    }, [isFromActionAndLoaded, subscription]);
};
